var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 44,
    viewBox: "0 0 59 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.700195 5.78479V43.6004H58.3002V0.400391H0.700195V5.78479ZM3.1002 7.66399L21.8202 22.3148L3.1002 38.6636V7.66399ZM3.8442 41.2004L23.745 23.8208L29.5002 28.3244L35.2554 23.8208L55.1562 41.2004H3.8442ZM55.9002 38.6636L37.1802 22.3136L55.9002 7.66279V38.6636ZM3.1002 2.80039H55.9002V4.61599L29.5002 25.2764L3.1002 4.61599V2.80039Z",
    fill: "#0061F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconBlue);
export default __webpack_public_path__ + "static/media/mail_icon_blue.b8c153d01f362b88acdeb249105515a0.svg";
export { ForwardRef as ReactComponent };